import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RestService } from '../providers/rest.service';
import { HelperProvider } from '../providers/helper.provider';
import { Page } from '../model/page';
import { Siparis } from '../model/siparis';
import { ParaBirimiTutar } from '../teklif/teklif.component';
import { Master } from '../model/master';
import { IrsaliyeKalem } from '../model/irsaliye-kalem';
import { IrsaliyeOlusturRequest } from '../model/irsaliye-olustur-request';
import { IrsaliyeOlusturRequestKalem } from '../model/irsaliye-olustur-request-kalem';
import { Irsaliye } from '../model/irsaliye';
import { SiparisSiparisOnaySeviye } from 'src/model/siparis-siparis-onay-seviye';
import { AuthService } from 'src/auth/auth.service';
import { TalepAciklama } from 'src/model/talep-aciklama';
import { MailRequest } from 'src/model/mail-request';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-siparis',
  templateUrl: './siparis.component.html',
  styleUrls: ['./siparis.component.css']
})
export class SiparisComponent implements OnInit, OnDestroy {


  public static ACTION_INCELE = 'incele';
  public static ACTION_IRSALIYE_OLUSTUR = 'irsaliye-olustur';

  subscriptions: Subscription[] = [];
  id = '';
  siparis: Siparis = null;

  DURUM_INITIAL = Siparis.DURUM_ONAY_BEKLIYOR;
  DURUM_ONAYLANDI = Siparis.DURUM_ONAYLANDI;
  DURUM_IRS_OLUSTU = Siparis.DURUM_IRSALIYE_OLUSTURULDU;
  totalTutarText = '';
  paraBirimleri: Master[] = null;
  irsaliyeEkle = false;
  yeniIrsaliyeKalem: IrsaliyeKalem[] = null;
  totalIrsaliyeText = '';
  irsaliyeNotu = '';
  irsaliyeTarihi: Date = new Date();
  irsaliyeNo = '';

  ACTION_INCELE = SiparisComponent.ACTION_INCELE;
  ACTION_IRSALIYE_OLUSTUR = SiparisComponent.ACTION_IRSALIYE_OLUSTUR;

  currentAction = this.ACTION_INCELE;
  userGrupId: number;
  siparisHareketler: SiparisSiparisOnaySeviye[] = null;
  talepAciklama: string;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private restService: RestService,
    private helperProvider: HelperProvider,
    private authService: AuthService,
    private toastrService: ToastrService) {
  }

  ngOnInit(): void {
    this.userGrupId = this.authService.getUser().kullaniciGrupId;
    this.helperProvider.currentPage$.next(Page.Siparisler);
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      if (params.action != null && params.action === this.ACTION_IRSALIYE_OLUSTUR) {
        this.currentAction = params.action;
      }
      this.id = params.id;
      if (this.id != null && this.id !== '0') {
        this.getSiparis();
      } else {
        this.router.navigate(['404']);
      }
      if (this.currentAction === this.ACTION_IRSALIYE_OLUSTUR) {
        this.irsaliyeEkle = true;
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getSiparis() {
    this.irsaliyeEkle = false;
    this.restService.siparis(this.id).subscribe(res => {
      if (res) {
        this.siparis = res;
        // console.log(res);
        this.restService.getSiparisHareketler(this.id).subscribe(res2 => {
          this.siparisHareketler = res2;
        });

        this.restService.siparisIrsaliyeleri(this.id).subscribe(rz => {
          this.siparis.irsaliyeler = rz;
          // console.log(rz);
        });

        this.restService.getMasterTypes([Master.ParaBirimi]).subscribe(result => {
          if (result) {
            this.paraBirimleri = result.ParaBirimi?.map(x => new Master(x));
            this.calculateTotalTutarText();
          }
        });
      } else {
        this.router.navigate(['404']);
      }
    });
  }

  talepGit() {
    this.router.navigate(['talep'], { queryParams: { id: this.siparis.talep.id } });
  }

  calculateTotalTutarText() {
    const array: ParaBirimiTutar[] = [];
    if (this.paraBirimleri) {
      for (const pb of this.paraBirimleri) {
        array.push(new ParaBirimiTutar(pb, 0));
      }
    }
    for (const t of this.siparis.siparisKalemler) {
      const index = array.findIndex(x => x.paraBirimi.id === t.teklifKalem.paraBirimi.id);
      if (index !== -1) {
        array[index].tutar += t.teklifKalem.tutar * t.miktar;
      }
    }

    const textArray = [];
    for (const e of array) {
      if (e.tutar !== 0) {
        textArray.push(`${e.tutar.toLocaleString("tr-Tr")} ${e.paraBirimi.aciklama}`);
      }
    }
    this.totalTutarText = textArray.join(' + ');
  }

  calculateIrsaliyeTotalTutarText() {
    const array: ParaBirimiTutar[] = [];
    if (this.paraBirimleri) {
      for (const pb of this.paraBirimleri) {
        array.push(new ParaBirimiTutar(pb, 0));
      }
    }
    for (const t of this.yeniIrsaliyeKalem) {
      const index = array.findIndex(x => x.paraBirimi.id === t.paraBirimiId);
      if (index !== -1) {
        array[index].tutar += t.tutar * t.adet;
      }
    }

    const textArray = [];
    for (const e of array) {
      if (e.tutar !== 0) {
        textArray.push(`${e.tutar.toLocaleString("tr-Tr")} ${e.paraBirimi.aciklama}`);
      }
    }
    this.totalIrsaliyeText = textArray.join(' + ');
  }

  addIrsaliye() {
    this.irsaliyeEkle = true;
    this.yeniIrsaliyeKalem = [];
    for (const siparisKalem of this.siparis.siparisKalemler) {
      const irsaliyeKalem = new IrsaliyeKalem();
      irsaliyeKalem.teklifKalemId = siparisKalem.teklifKalemId;
      irsaliyeKalem.tutar = siparisKalem.teklifKalem.tutar;
      irsaliyeKalem.adet = siparisKalem.miktar;
      irsaliyeKalem.paraBirimiId = siparisKalem.teklifKalem.paraBirimiId;
      this.yeniIrsaliyeKalem.push(irsaliyeKalem);
    }
    this.calculateIrsaliyeTotalTutarText();
  }

  irsaliyeKaydet() {
    if (this.irsaliyeNo.length > 15) {
      this.toastrService.warning("İrsaliye numarası 15 karakterden fazla olamaz!", "Uyarı!");
      return;
    }

    const request = new IrsaliyeOlusturRequest();
    request.id = null;
    request.irsaliyeNo = this.irsaliyeNo;
    request.irsaliyeNotu = this.irsaliyeNotu;
    request.irsaliyeTarihi = this.irsaliyeTarihi;
    request.siparisId = Number(this.id);
    request.irsaliyeKalemler = [];
    for (const irsaliyeKalem of this.yeniIrsaliyeKalem) {
      const kalem = new IrsaliyeOlusturRequestKalem();
      kalem.teklifKalemId = irsaliyeKalem.teklifKalemId;
      kalem.adet = irsaliyeKalem.adet;
      kalem.tutar = irsaliyeKalem.tutar;
      kalem.paraBirimiId = irsaliyeKalem.paraBirimiId;
      request.irsaliyeKalemler.push(kalem);
    }
    this.restService.irsaliyeKaydet(request).subscribe(res => {
      if (res) {
        debugger;
        const mailRequest = new MailRequest();
        mailRequest.subject = res.siparis.talep.talepNo + " NOLU SİPARİŞ TESLİM ALINDI ( " + res.irsaliyeNo + " )";
        mailRequest.template = MailRequest.SIPARIS_ALINDI_FORMU;
        mailRequest.irsaliyeId = res.id;

        this.restService.mailGonder(mailRequest).subscribe(res2 => {
        });
      }
      this.getSiparis();
    });
  }

  irsaliyeDetay(ir: Irsaliye) {
    this.router.navigate(['irsaliye'], { queryParams: { id: ir.id } });

  }

  siparisOnayla(id: number, isOnay: boolean) {
    const request = new SiparisSiparisOnaySeviye();
    request.siparisId = this.siparis.id;
    request.siparisOnaySeviyeId = id;
    request.isOnay = isOnay;
    this.restService.siparisOnayla(request).subscribe(res => {
      if (res && res.siparisOnaySeviye === null) {
        const mailRequest = new MailRequest();
        mailRequest.subject = "SİPARİŞ BİLGİLERİ";
        mailRequest.template = MailRequest.SIPARIS_FORMU;
        mailRequest.siparisIdler = [];
        mailRequest.siparisIdler.push(res.id);

        this.restService.mailGonder(mailRequest).subscribe(res2 => {
        });
      }

      if (this.talepAciklama !== "" && this.talepAciklama !== undefined) {
        const aciklama = new TalepAciklama;
        aciklama.talepId = this.siparis.talep.id;
        aciklama.aciklama = this.talepAciklama;

        this.restService.talepAciklamaKaydet(aciklama).subscribe(res2 => {
        });
      }
      this.getSiparis();
    });
  }

  setAciklama(event: string) {
    this.talepAciklama = event;
  }

  siparisKapat() {
    this.restService.siparisKapat(this.siparis.id).subscribe(res => {
      this.getSiparis();
    });
  }
}



